import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ContributorsAdapterCardShared,
  type ContributorsAdapterSchemaType,
  type ContributorsAdapterContext,
  CONTRIBUTORS_ADAPTER,
} from '@scale/genai-compass-shared/cards/contributors_adapter';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import ContributorsAdapterCardComponent from './ContributorsAdapterCardComponent';
import { INPUT_COLUMNS } from './constants';

const defaultContext: ContributorsAdapterContext = {
  cardType: CONTRIBUTORS_ADAPTER,
  searchMode: 'Search',
  contributorIdsOrEmails: [],
  filter: {
    operator: 'and',
    filtersOrFilterGroups: [
      {
        column: INPUT_COLUMNS.workerTeamId,
        condition: 'is',
        term: '',
      },
    ],
  },
  includeAllProjectData: false,
  includeAllWorkerSkillData: false,
  excludeFraudHolding: true,
};

export const ContributorsAdapterCardInfo: CompassCardUI<ContributorsAdapterSchemaType> = {
  ...ContributorsAdapterCardShared,
  title: 'Contributors Search',
  icon: 'people',
  toolTip: 'Search for Contributor data.',
  defaultContext,
  button: {
    title: 'Contributors',
    icon: faUsers,
  },
  legacyComponent: ContributorsAdapterCardComponent,
};
